import { all, call, put, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import {
  addAttribute,
  addAttributeFailed,
  addAttributeSuccess,
  attributeDelete,
  attributeDeleteFailed,
  attributeDeleteSuccess,
  getAttributes,
  getAttributesFailed,
  getAttributesSuccess,
} from './slice';
import * as endpoints from './endpoints';
import { setPageCount } from '../common';

// ----------------------------------------
function* getAttributesSaga(action: ReturnType<typeof getAttributes>): any {
  const { page, q, limit = 100 } = action.payload;
  try {
    const result = yield call(request.get, endpoints.getAttribute, {
      params: {
        limit,
        page: q ? 1 : page,
        q,
      },
    });
    yield put(getAttributesSuccess(result.data.attribute));
    yield put(setPageCount({ id: action.type, count: result.data.total }));
  } catch (err: any) {
    yield put(getAttributesFailed(err));
  }
}

// ----------------------------------------

function* addAttributeSaga(action: ReturnType<typeof addAttribute>): any {
  try {
    const { id, name, isPrefix, showAsFilter, attributes } = action.payload;

    const prefixes = attributes?.map((item: { prefix: string | number }) => item?.prefix);

    let result: any;
    if (id) {
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      result = yield call(request.put, endpoints.updateAttribute + id, {
        name,
        showAsFilter,
        isPrefix,
        attributePrefix: prefixes?.length > 0 ? prefixes : [],
      });
    } else {
      result = yield call(request.post, endpoints.addAttribute, {
        name,
        showAsFilter,
        isPrefix,
        attributePrefix: prefixes?.length > 0 ? prefixes : [],
      });
    }
    yield put(addAttributeSuccess(result.data));
    yield put(getAttributes({ page: 1 }));
  } catch (err: any) {
    yield put(addAttributeFailed(err));
  }
}

// ----------------------------------------

function* attributeDeleteSaga(action: ReturnType<typeof attributeDelete>): any {
  const { id } = action.payload;
  try {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    const result = yield call(request.delete, endpoints.deleteAttribute + id);

    yield put(attributeDeleteSuccess(result.data));
    yield put(getAttributes({ page: 1 }));
  } catch (err: any) {
    yield put(attributeDeleteFailed(err));
  }
}

// ----------------------------------------

function* attributeSagas() {
  yield all([
    takeLatest(getAttributes, getAttributesSaga),
    takeLatest(addAttribute, addAttributeSaga),
    takeLatest(attributeDelete, attributeDeleteSaga),
  ]);
}

export { attributeSagas };
